(function () {
const $5434ab116c87cda5$var$validAnswers = {
    'b6357b78-776c-4e3d-b0e9-b8e84a606f94': [
        'B'
    ],
    '316e4e58-1ab1-472c-8812-e3d0d8ad6e2d': [
        'A'
    ],
    '8f1e3b68-1535-4002-9f73-b8dfa4ddddc3': [
        'B'
    ],
    '721aab31-d09c-4815-ba4e-99de5f89d891': [
        'C'
    ],
    '453d8c50-63ab-4d91-8c1f-0da492992cae': [
        'A'
    ],
    'c33ee305-c468-48a5-8f47-d71c0de3b582': [
        'D'
    ],
    '75642b50-b33c-440f-b794-3d05349c37ee': [
        'A'
    ],
    '5ec19679-b68c-4e0c-92c2-67f913d18b13': [
        'C'
    ],
    '38f043a4-ebc2-476b-b0c3-00cebebc4781': [
        'B'
    ],
    '69642b3d-2969-47c7-a72f-b72832aecaeb': [
        'D'
    ],
    'd256e4e5-80f5-42e6-96ca-bc11a8483702': [
        'C'
    ],
    '72cb0c2a-17b7-4ada-b846-00985d3e1cf0': [
        'B'
    ],
    'f09e97c7-e355-4067-bca6-47d9b18de3f5': [
        'C'
    ],
    '10733794-ad7b-4041-818a-0ef69d1d1219': [
        'A'
    ],
    '09a0f788-8523-4e13-9ceb-05c3b8503c48': [
        'C'
    ],
    '4df50a5f-83fe-45f9-940e-07926b44563f': [
        'A'
    ],
    '23bcd0eb-4597-4b6c-97e0-54c7deb0cc12': [
        'D'
    ],
    '11dd5595-6d50-4744-b58e-334c28bbd44b': [
        'C'
    ],
    'f9fdc01d-995b-4a36-87a9-04eb05a821b9': [
        'D'
    ],
    'ddd06cc9-db01-47bc-9d28-fe6e7ee87b3f': [
        'D'
    ],
    'ee0d38a7-966a-4435-9407-e757e90819dd': [
        'A'
    ],
    '5ed13acf-2bb3-4b8b-ad91-eb52da9c34e0': [
        'A'
    ],
    'd59df0f3-714a-4774-b10e-c8c63f3363d3': [
        'A',
        'B',
        'C',
        'D'
    ],
    '5249fc28-36e4-467a-bb21-310759b52524': [
        'D'
    ],
    '7aff8551-3a98-49d3-8f5d-61862db50861': [
        'D'
    ],
    '8f5f1d81-47a6-4d4a-8bb6-92211969de00': [
        'B'
    ],
    '308a1fb3-68e8-4c00-8af3-e905eecc2d80': [
        'A'
    ],
    '3dadc127-f7c4-474a-9401-2de2819330e3': [
        'A'
    ],
    'b58d1934-2331-49ed-95bd-ec430fb5151e': [
        'A'
    ],
    'ab6ebc7d-6b8f-464c-bacd-9fad8953c6d3': [
        'B'
    ],
    '8e667eb4-4c66-4268-b4e4-d56797df4248': [
        'B'
    ],
    '5fae4d83-f620-433d-b73d-12bb5ef375e7': [
        'A'
    ]
};
const $5434ab116c87cda5$var$greenColor = '#138500';
const $5434ab116c87cda5$var$redColor = '#d11c1c';
const $5434ab116c87cda5$var$initStart = ()=>{
    const $allElements = document.querySelectorAll('[data-poll-step]');
    $allElements.forEach((element)=>{
        const $currentButton = element.querySelector('[data-submit]');
        if ($currentButton) $currentButton.addEventListener('click', $5434ab116c87cda5$var$goNext);
        const $currentInput = element.querySelectorAll('input[id]');
        $currentInput.forEach((input)=>{
            const isCheckbox = input.type === 'checkbox';
            if (isCheckbox) input.addEventListener('click', ()=>{
                const checkedInput = element.querySelectorAll('input[type="checkbox"]:checked').length;
                checkedInput > 0 ? $currentButton.disabled = false : $currentButton.disabled = true;
            });
            else input.addEventListener('click', ()=>{
                $currentButton.disabled = false;
            });
        });
    });
    const $endButton = document.querySelector('[end-quiz]');
    $endButton.addEventListener('click', $5434ab116c87cda5$var$onEndButton);
};
const $5434ab116c87cda5$var$goNext = (event)=>{
    const $currentButtonStep = event.currentTarget;
    const stepNumber = $currentButtonStep.dataset.shouldStepTo;
    const $allToHide = document.querySelectorAll('[data-poll-step]');
    $allToHide.forEach((element)=>{
        element.hidden = true;
    });
    const $nextQuestion = document.querySelector(`[data-poll-step='${stepNumber}']`);
    $nextQuestion.hidden = false;
};
const $5434ab116c87cda5$var$onEndButton = ()=>{
    $5434ab116c87cda5$var$createObjectWithAnswers();
    $5434ab116c87cda5$var$countScore($5434ab116c87cda5$var$answersObject, $5434ab116c87cda5$var$scoreFromCheckbox);
    $5434ab116c87cda5$var$endQuiz();
};
const $5434ab116c87cda5$var$answersObject = {};
let $5434ab116c87cda5$var$scoreFromCheckbox = 0;
const $5434ab116c87cda5$var$createObjectWithAnswers = ()=>{
    const $buttons = document.querySelectorAll('[data-question]');
    $buttons.forEach((element)=>{
        const questionId = element.getAttribute('data-question');
        const $checkedRadioButton = element.querySelector('input[type=radio]:checked');
        if ($checkedRadioButton !== null) $5434ab116c87cda5$var$answersObject[questionId] = [
            $checkedRadioButton.value
        ];
        else $5434ab116c87cda5$var$scoreFromCheckbox = element.querySelectorAll('input[type=checkbox]:checked').length;
    });
};
const $5434ab116c87cda5$var$countScore = (answersObject, scoreFromCheckbox)=>{
    const responseResults = Object.keys(answersObject).map((key)=>JSON.stringify(answersObject[key]) === JSON.stringify($5434ab116c87cda5$var$validAnswers[key]));
    const score = responseResults.filter(Boolean).length + scoreFromCheckbox;
    const $points = document.querySelector('[data-scored-points]');
    $points.textContent = score.toString();
};
const $5434ab116c87cda5$var$endQuiz = ()=>{
    $5434ab116c87cda5$var$deleteElements();
    $5434ab116c87cda5$var$showQuestions();
    $5434ab116c87cda5$var$showCorrectAnswers();
    $5434ab116c87cda5$var$showWrongAnswers();
};
const $5434ab116c87cda5$var$deleteElements = ()=>{
    const $startElement = document.querySelector('[data-poll-step]');
    const $buttonsToDelete = document.querySelectorAll('[data-submit]');
    $startElement.remove();
    $buttonsToDelete.forEach((button)=>{
        button.remove();
    });
};
const $5434ab116c87cda5$var$showQuestions = ()=>{
    const $allQuestions = document.querySelectorAll('[data-poll-step]');
    $allQuestions.forEach((question)=>{
        const $inputs = question.querySelectorAll('[id]');
        $inputs.forEach((answer)=>{
            answer.disabled = true;
        });
        question.hidden = false;
    });
};
const $5434ab116c87cda5$var$showCorrectAnswers = ()=>{
    Object.keys($5434ab116c87cda5$var$validAnswers).map((key)=>{
        const $data_question = document.querySelector(`[data-question='${key}']`);
        const isCheckbox = $5434ab116c87cda5$var$validAnswers[key].length > 1;
        if (isCheckbox) {
            const $checkbox = document.querySelector(`[data-question='${key}']`);
            const $checkboxInput = $checkbox.querySelectorAll('input[type=checkbox]');
            $checkboxInput.forEach((element)=>{
                element.classList.add('correct');
                const $label = document.querySelector(`[for=${element.id}]`);
                $label.style.color = $5434ab116c87cda5$var$greenColor;
            });
        } else {
            const $correctValue = $data_question.querySelector(`input[value='${$5434ab116c87cda5$var$validAnswers[key]}']`);
            const $answerText = document.querySelector(`[for=${$correctValue.id}]`);
            $correctValue.classList.add('correct');
            $answerText.style.color = $5434ab116c87cda5$var$greenColor;
        }
    });
};
const $5434ab116c87cda5$var$showWrongAnswers = ()=>{
    Object.keys($5434ab116c87cda5$var$answersObject).map((key)=>{
        const $data_question = document.querySelector(`[data-question='${key}']`);
        const $checkedInput = $data_question.querySelector('input[type=radio]:checked');
        const $answerText = document.querySelector(`[for=${$checkedInput.id}]`);
        if (!$checkedInput.classList.contains('correct')) {
            $checkedInput.classList.add('invalid');
            $answerText.style.color = $5434ab116c87cda5$var$redColor;
        }
    });
};
var $5434ab116c87cda5$export$2e2bcd8739ae039 = $5434ab116c87cda5$var$initStart;


function $e9a587e741e13f58$var$init() {
    (0, $5434ab116c87cda5$export$2e2bcd8739ae039)();
}
$e9a587e741e13f58$var$init();

})();
//# sourceMappingURL=script.js.map
